module.exports = __webpack_public_path__ + "static/media/05_MEDS-1.7-ES-10 1.0ee70bbe.svg";